<template>
  <div v-if="showCreateList" class="create-list">
    <img src="../../../assets/icons/checkmark.png" alt="checkmark" />
    <h2>CREATE A REQUEST LIST</h2>
    <p>
      Based on your inspection report, do you have any repair requests?
      You can build a list right here, making it easy for your real
      estate agent to negotiate with the seller.
    </p>
    <hg-create-list-button
      :hg-eligible-reports="hgEligibleReports"
      :hg-button-style="'v-btn-secondary'"/>
  </div>
</template>

<script>
import CreateListButton from './CreateListButton.vue';

export default {
  props: {
    hgCreateList: {
      required: true,
      type: Object,
    },
    hgEligibleReports: {
      type: Array,
      required: true,
    },
  },
  components: {
    'hg-create-list-button': CreateListButton,
  },
  computed: {
    showCreateList() {
      const {
        blocked,
        enableRequestList,
        homeInspectionReportCount,
        requestListCount,
      } = this.hgCreateList;

      return homeInspectionReportCount > 0
        && blocked === false
        && enableRequestList === true
        && requestListCount === 0
        && this.hgEligibleReports.length > 0;
    },
  },
};

</script>


<style lang='scss' scoped>
@import '../../../styles/vars/theme';
@import '../../../styles/vars/typography';

.create-list {
  background-color: rgb(93, 93, 93);
  color: rgb(216, 216, 216);
  font-family: $typography-font-secondary;
  font-weight: $typography-weight-normal;
  height: 300px;
  margin-bottom:30px;
  min-width: 350px;
  padding: 40px;
  text-align: center;
}

p {
  font-weight: $typography-weight-bold;
  margin: 0 auto;
  max-width: 550px;
  padding-bottom: 30px;
}

h2 {
  color: $theme-color-white;
  padding-bottom: 10px;
}

@media all and (max-width: 655px) {
  .create-list {
    margin-bottom: 0;
  }
}
</style>
